import { PortfoliosStatementsService_portfolioStatementsServiceGetStatement } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosStatementsService_portfolioStatementsServiceGetStatement'

export const useFetchPortfolioStatementsNoSuspense =
  PortfoliosStatementsService_portfolioStatementsServiceGetStatement.useQuery
